/* @flow */

import { type AxiosPromise } from 'axios';
import xhr from '../utils/xhr';
import { type Cores } from '../empresa/types';

const getCoresPorEmpresasId = (empresasId: number): AxiosPromise<Cores> => xhr.get(`/empresas/${empresasId}/cores`);

export default getCoresPorEmpresasId;
